'use client';
import React, { Suspense, lazy } from 'react';
import { use } from 'react';
import { DialogContext } from './context/DialogContext';
import { DIALOGS } from './context/DialogContext';
const GlobalDialogs = () => {
  const { isOpen, closeDialog, getDialogProps } = use(DialogContext);
  const dialogKeys = Object.keys(DIALOGS) as (keyof typeof DIALOGS)[];
  return (
    <Suspense>
      {dialogKeys.map((key) => {
        const componentName =
          key
            .split('-')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join('') + 'Dialog';

        const Dialog = isOpen(key)
          ? lazy(() => import(`../${componentName}`))
          : null;

        return (
          Dialog && (
            <Dialog
              key={key}
              open={isOpen(key)}
              onOpenChange={() => closeDialog(key)}
              {...getDialogProps(key)}
            />
          )
        );
      })}
    </Suspense>
  );
};

export default GlobalDialogs;
